// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3Bxdy{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;font-size:14px;font-weight:300;line-height:23px;font-family:var(--base-font)}@media(max-width:767px){._3Bxdy{font-size:16px;line-height:26px}}a._3JmT3{color:#595757;cursor:pointer;display:-ms-flexbox;display:flex;padding-bottom:.125rem}a._3JmT3:hover{color:#0373f9}._2a0Ad path[fill]{fill:#9fa0a0}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "_3Bxdy",
	"link": "_3JmT3",
	"icon": "_2a0Ad"
};
module.exports = exports;
